'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolve = require('./private/renderer/resolve');

var _TagTypes = require('./private/types/TagTypes');

var _ContextProps = require('./private/types/ContextProps');

var _Identifiers = require('./private/types/Identifiers');

var _getByIdentifier = require('./private/tags/values/get-by-identifier');

var _updateByIdentifier = require('./private/tags/values/update-by-identifier');

var _identify = require('./private/renderer/utils/identify');

var _clone = require('./private/renderer/utils/clone');

var _renderToStaticMarkup = require('./private/renderer/render-to-static-markup');

module.exports = {
  renderToStaticMarkup: _renderToStaticMarkup.renderToStaticMarkup,
  renderJsonLd: _renderToStaticMarkup.renderJsonLd,
  resolve: _resolve.resolve,
  resolvePayload: _resolve.resolvePayload,
  updateValueByIdentifier: updateValueByIdentifier,
  getValueByIdentifier: getValueByIdentifier,
  CONTEXT_PROPS: _ContextProps.CONTEXT_PROPS,
  EXTERNAL_IDENTIFIERS: _Identifiers.EXTERNAL_IDENTIFIERS,
  getTitle: getTitle,
  getDescription: getDescription,
  getCanonical: getCanonical,
  getMetaTags: getMetaTags,
  setTitle: setTitle,
  setDescription: setDescription,
  setCanonical: setCanonical,
  addMetaTag: addMetaTag
};

function updateValueByIdentifier() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var identifier = arguments[1];
  var value = arguments[2];
  var meta = arguments[3];

  var tags = data && data.tags || [];
  var updatedTags = (0, _updateByIdentifier.updateValueByIdentifier)(tags, identifier, value, meta);
  return _extends({}, data, {
    tags: updatedTags
  });
}

function getValueByIdentifier() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      tags = _ref.tags;

  var identifier = arguments[1];

  return (0, _getByIdentifier.getValueByIdentifier)(tags, identifier);
}

function getTitle(data) {
  return getValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.TITLE);
}

function setTitle(data, title) {
  return updateValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.TITLE, title);
}

function getDescription(data) {
  return getValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.DESCRIPTION);
}

function setDescription(data, description) {
  return updateValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS, description);
}

function getCanonical(data) {
  return getValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.CANONICAL);
}

function setCanonical(data, canonical) {
  return updateValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.CANONICAL, canonical);
}

function getMetaTags(data, filter) {
  var tags = (data || {}).tags;
  if (Array.isArray(tags)) {
    return tags.reduce(function (acc, curr) {
      if (curr && curr.type === _TagTypes.TAG_TYPES.META && curr.props) {
        if (filter) {
          var matches = Object.keys(filter).every(function (key) {
            return curr.props[key] === filter[key];
          });
          if (!matches) {
            return acc;
          }
        }
        return acc.concat(curr.props);
      }
      return acc;
    }, []);
  }
  return [];
}

function addMetaTag(data, props) {
  var identifier = (0, _identify.identify)({
    type: _TagTypes.TAG_TYPES.META,
    props: props
  });
  if (identifier) {
    return updateValueByIdentifier(data, identifier, props.content);
  }
  var result = (0, _clone.clone)(data);
  result.tags.push({
    type: _TagTypes.TAG_TYPES.META,
    props: props
  });
  return result;
}